import { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getPaymentFrequencyMonths, getPaymentFrequencyDays, getPaymentFrequencyText } from 'features/User/selectors';
import { setCancellationStep } from 'features/User/slice';

export const usePromptStepService = () => {
  const paymentFrequencyMonths = useSelector(getPaymentFrequencyMonths);
  const paymentFrequencyDays = useSelector(getPaymentFrequencyDays);
  const paymentFrequencyText = useSelector(getPaymentFrequencyText);

  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(setCancellationStep(null));
  }, [dispatch]);

  const handleConfirm = useCallback(() => dispatch(setCancellationStep('feedback')), [dispatch]);

  const keepPlanText = useMemo(() => {
    if (paymentFrequencyDays !== null) {
      return `Keep my ${paymentFrequencyText} subscription`;
    }
    return `Keep my ${paymentFrequencyMonths} month subscription`;
  }, [paymentFrequencyMonths, paymentFrequencyDays, paymentFrequencyText]);

  return { keepPlanText, handleClose, handleConfirm };
};
